import { DmReadingsTable } from "@/components/mqtt/dm-readings-table";
import { ReadingsTable } from "@/components/mqtt/readings-table";
import { RmReadingsTable } from "@/components/mqtt/rm-readings-table";
import { useEffectiveRole } from "@/hooks/use-effective-role";

export function ReadingsPage() {
	const role = useEffectiveRole();

	return (
		<div className="flex min-h-0 flex-1 flex-col gap-4 p-4 lg:p-6">
			{role === "reseller_manager" ? (
				<RmReadingsTable />
			) : role === "district_manager" ? (
				<DmReadingsTable />
			) : (
				<ReadingsTable />
			)}
		</div>
	);
}
